module.exports = __webpack_public_path__ + "static/estate-945c265def75d6ba2af7593012f30be2.png";